import axios from 'axios'
import router from './../../../router'
import {Errors, Form} from './../../../components/validations/forms.js'
const namespaced = true;

const state = {
  leaves: [],
  leaveTypes: [],

  defaultSearchFilter: {
    leaveID: null,
    leaveID2: null,
    userID: null,
    userID2: null,
    dateFrom: null,
    dateFrom2: null,
    dateTo: null,
    dateTo2: null,
    leaveType: null,
    leaveType2: null,
    resultsView: 'leaves',
  },
  searchFilter: {
    leaveID: null,
    leaveID2: null,
    userID: null,
    userID2: null,
    dateFrom: null,
    dateFrom2: null,
    dateTo: null,
    dateTo2: null,
    leaveType: null,
    leaveType2: null,
    resultsView: 'leaves',
  },

  sorting: {
    page: 1,
    sortBy: 'id',
    sortOrder: 'desc',
    limit: 7,
  },

  timesheetUsers: [],
  timesheetPages: [],

};

const getters = {
  getLeaves (state) {
    return state.leaves
  },

  getLeaveTypes (state) {
    return state.leaveTypes
  },

  getDefaultSearchFilters (state) {
    return state.defaultSearchFilter
  },

  getSearchFilters (state) {
    return state.searchFilter
  },

  getSorting (state) {
    return state.sorting
  },

  getTimesheetPages (state) {
    return state.timesheetPages
  },

  getTimesheetUsers (state) {
    return state.timesheetUsers
  },


};


const mutations = {
  setLeaves (state, payload) {
    state.leaves = payload
  },

  setLeaveTypes (state, payload) {
    state.leaveTypes = payload
  },

  resetSearchFilters (state, payload){
    state.searchFilter = JSON.parse(JSON.stringify(state.defaultSearchFilter));
    console.log('Search Filter Reset')
  },

  setTimesheetPages (state, payload) {
    state.timesheetPages = payload
  },

  setTimesheetUsers (state, payload) {
    state.timesheetUsers = payload
  },

};


const actions = {

  fetchTimesheetUsers ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/attendance/leave', {
        params: {
          leaveID: payload.filters.leaveID,
          userID: payload.filters.userID,
          dateFrom: payload.filters.dateFrom,
          dateTo: payload.filters.dateTo,
          leaveType: payload.filters.leaveType,
          resultsView: payload.filters.resultsView,
          limit: payload.sorting.limit,
          page: payload.sorting.page,
          sortBy: payload.sorting.sortBy,
          sortOrder: payload.sorting.sortOrder,
        }
      })
          .then(res => {
            commit('setTimesheetUsers', res.data.data)
            commit('setTimesheetPages', {meta: res.data.meta, links:res.data.links})

            console.log('fetchTimesheetUsers - Leaves Data Fetched.');
            resolve(res.data.data);
          })
          .catch(error => {
            const issues = new Errors();
            issues.record(error.response);
            reject(issues);
          })
    })
  },



  fetchLeaveTypes ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/attendance/leave/leaveTypes', {
        params: {
        }
      })
        .then(res => {
          commit('setLeaveTypes', res.data.data)
          console.log('fetchLeaveTypes - Leave Types Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  updateLeave ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.put('/api/attendance/leave/'+payload.id, {
        dateFrom: payload.dateFrom,
        dateTo: payload.dateTo,
        leaveType: payload.leaveType,
        description: payload.description,
      })
        .then(res => {
          console.log('updateLeave - Leave Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },



  storeLeave ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.post('/api/attendance/leave', {
        description: payload.description,
        userID: payload.userID,
        dateFrom: payload.dateFrom,
        dateTo: payload.dateTo,
        leaveType: payload.leaveType,
      })
        .then(res => {
          console.log('storeLeave - Leave Updated.');
          resolve(res.data);
        })
        .catch(error => {
            reject(error.response);
        })
    })
  },




  deleteLeave ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.delete('/api/attendance/leave/'+payload.id)
        .then(res => {
          console.log('deleteLeave - Leave Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },
  resetSearchFilters ({commit, dispatch}) {
    commit('resetSearchFilters');
    console.log('Search Filters were reset');
  },

};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/leaves/leaves.js